import { render } from "./DownloadExportCapture.vue?vue&type=template&id=87dd3094"
import script from "./DownloadExportCapture.vue?vue&type=script&lang=ts"
export * from "./DownloadExportCapture.vue?vue&type=script&lang=ts"
script.render = render

export default script